import { tv } from "@pcln/horizon";
const heroCollectionVariants = tv({
    slots: {
        root: '@container flex w-full max-w-[1232px] flex-col gap-4',
        headingBlock: 'flex flex-col gap-1',
        headingRow: 'flex items-center gap-6',
        desktopLink: 'hidden items-center gap-2 pt-1 @md:flex',
        mobileLink: 'flex @md:hidden'
    }
});
export { heroCollectionVariants };
